import {computed, makeObservable} from 'mobx';
import {PersonalMenuCollection} from './PersonalMenuCollection';
import {getUuid4} from '../../../../utils/getUuid4';
import {Field} from '../../Common/stores/Field';
import {EntityType} from '../../../../constants/EntityTypes';
import * as fieldTypes from '../../../../constants/FieldTypes';

export class PersonalMenuField extends Field {
    exec;
    constructor(field, parentField) {
        super(field, parentField);
        makeObservable(this);
        this.exec = field.exec;
        this.name = getUuid4();

        this.type = field.type === EntityType.MENU ? fieldTypes.TAB : field.type;
        this.collection = new PersonalMenuCollection(parentField.collection);
    }

    setCollection(field) {
        field.fields && this.collection.insertFields(this, field.fields);
    }

    @computed get isMovable() {
        return !this.hidden;
    }

    @computed
    get isDoubleTitleAllowed() {
        return true;
    }
}
